"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateCep = void 0;

exports.validateCep = function () {
  var regex = /^\d{5}-\d{3}$/;
  return function (cep) {
    return typeof cep === 'string' && regex.test(cep);
  };
}();